/*listHover.js*/

import { gsap } from "gsap";

let list;
let marker;
let dataHoverEls;

let buttons;
// flag to control if animation is on or off
let isAnimated = false;

const setList = () => {

  list = document.querySelector('[data-hover-list]');
  marker = document.querySelector('[data-hover-marker]');
  dataHoverEls = document.querySelectorAll('[data-target-id]');

  if ( ! list ) return;

  dataHoverEls.forEach(item => {
    // if item isn't initial/first person
    if ( item.getAttribute('data-target-id') > 1) {
      
      if (isAnimated) {
        gsap.set(item, {
          yPercent: "10", 
          autoAlpha: 0,
        })
       }

    }
  })

  list.addEventListener("mouseover", handleMouseOver);

  console.log('built the list');
}

const destroyList = () => {
  if ( ! list ) return;
  list.removeEventListener("mouseover", handleMouseOver);

  if ( ! buttons.length ) return;
  buttons.forEach(button => {
    button.removeEventListener("click", handleClick);
  })

  console.log('destroyed the list');
}

function handleMouseOver() {
  // control the marker position
  gsap.to(marker, {top: event.target.offsetTop, duration: 0.25, ease: "power1.out"});    

  //if e.target is li element
  if(event.target.hasAttribute('data-hover-id')) {

    dataHoverEls.forEach(item => {
      if (event.target.getAttribute('data-hover-id') == item.getAttribute('data-target-id')) {
        if (isAnimated) {
          gsap.set(item, {zIndex:10})
          gsap.to(item, { yPercent: "0", delay: 0.25, duration: .75, ease: "power1.out", autoAlpha: 1, overwrite:true });
        } else {
          gsap.to(item, { yPercent: "0", delay: 0, duration: 0, ease: "none", autoAlpha: 1, overwrite:true });
        }
      } else {
        if (isAnimated) {
          gsap.set(item, {zIndex:5})
          gsap.to(item, { yPercent: "0", delay: 0, duration: .5, ease: "power1.out", autoAlpha: 0, overwrite:true, onComplete: function(){ gsap.set(item, {yPercent: "10"}) }});
        } else {
          gsap.to(item, { yPercent: "0", delay: 0, duration: 0, ease: "none", autoAlpha: 0, overwrite:true });
        }
      }
    })

  }
}

const setDirectorHover = () => {

  buttons = document.querySelectorAll('[data-button]');

  if ( buttons.length && document.body.classList.contains('is-mobile')) {
    buttons.forEach(button => {
      button.addEventListener("click", handleClick);
    })
  }

}

function handleClick() {
  console.log(event.target.closest('.director'));
  let director = event.target.closest('.director')
  director.classList.toggle('is-active');
}

export {setList, destroyList, setDirectorHover};